export default __webpack_public_path__ + "static/media/gallery26.960a7648.webp";